// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__vyu_3","titleContainer":"style_titleContainer__28vd_","icon":"style_icon__1Urec"};